<template>
  <div class="app" :class="classes" @dragover.prevent @drop.prevent>
    <div class="loading d-none justify-content-center align-items-center">
      <div class="wrapper"></div>
      <font-awesome-icon
        slot="spinner"
        icon="spinner"
        size="2x"
        color="white"
        pulse
      />
    </div>
    <div class="cover d-none d-lg-block"></div>

    <div class="fixed-top">
      <b-container>
        <b-row>
          <b-col>
            <b-navbar class="primary" toggleable="lg">
              <b-navbar-brand
                class="d-flex d-lg-none justify-content-between justify-content-lg-around align-items-center"
              >
                <b-navbar-toggle target="nav">
                  <font-awesome-icon icon="bars" size="lg" />
                </b-navbar-toggle>
                <a href="/" class="navbar-toggler">
                  <img src="./assets/logo-inverse.png" class="logo-inverse" />
                </a>
                <router-link
                  :to="{
                    name: 'gallery',
                    params: {
                      category: 'all',
                      search: ''
                    }
                  }"
                  class="navbar-toggler"
                >
                  <font-awesome-icon icon="search" size="lg" />
                </router-link>
              </b-navbar-brand>
              <a href="/" class="d-none d-lg-block">
                <img
                  src="./assets/logo.png"
                  style="height: 30px; margin-right: 8px;"
                />
              </a>
              <b-collapse id="nav" is-nav>
                <b-navbar-nav class="primary-menu">
                  <b-nav-item to="/gallery/all/">
                    <div class="d-flex justify-content-between">
                      <div class="text-uppercase">Search</div>
                      <div class="d-block d-lg-none">
                        다양한 분야의 아티스트를 찾아보세요!
                      </div>
                    </div>
                  </b-nav-item>
                  <b-nav-item
                    href="https://axoo.notion.site/FOR-ARTISTS-12847ee5dd958155b08af81ddaa15014"
                    target="_blank"
                  >
                    <div class="d-flex justify-content-between">
                      <div class="text-uppercase">For Artists</div>
                      <div class="d-block d-lg-none">멤버십 가입하기</div>
                    </div>
                  </b-nav-item>
                  <b-nav-item to="/goodluck/">
                    <div class="d-flex justify-content-between">
                      <div class="text-uppercase">Goodluck</div>
                      <div class="d-block d-lg-none">굿럭</div>
                    </div>
                  </b-nav-item>
                  <b-nav-item to="/about/contact/" class="d-lg-none">
                    <div class="d-flex justify-content-between">
                      <div class="text-uppercase">Contact</div>
                      <div class="d-block">문의하기</div>
                    </div>
                  </b-nav-item>
                  <b-nav-item
                    :to="`/${user.slug}/`"
                    exact
                    class="d-lg-none"
                    v-if="user.id"
                  >
                    <div class="d-flex justify-content-between">
                      <div class="text-uppercase">My Pixpills</div>
                      <div class="d-block">마이 픽스필즈</div>
                    </div>
                  </b-nav-item>
                  <b-nav-item
                    href="/accounts/logout/"
                    class="d-lg-none"
                    v-if="user.id"
                  >
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <b-btn class="border mr-1" variant="outline-red" block
                        >LOGOUT</b-btn
                      >
                    </div>
                  </b-nav-item>
                  <b-nav-item class="d-lg-none" v-else>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <b-btn
                        to="/login/"
                        class="border mr-1"
                        variant="outline-red"
                        block
                        >LOG IN</b-btn
                      >
                      <b-btn
                        to="/signup/"
                        class="border ml-1 mt-0"
                        variant="outline-red"
                        block
                        >SIGN UP</b-btn
                      >
                    </div>
                  </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav> </b-navbar-nav>
                <b-navbar-nav
                  class="secondary-menu ml-auto d-none d-lg-flex align-items-center"
                >
                  <template v-if="user.id">
                    <li class="nav-item">
                      <b-link to="/upload/" class="nav-link btn btn-primary">
                        UPLOAD
                      </b-link>
                    </li>
                    <b-nav-item-dropdown class="avatar" @click.stop.prevent>
                      <template slot="button-content">
                        <img
                          :src="`${user.cropped_avatar}?width=156`"
                          class="rounded-circle"
                          v-if="user.cropped_avatar"
                        />
                        <img src="./assets/avatar.png" v-else />
                      </template>
                      <b-link
                        :to="`/${user.slug}/`"
                        class="dropdown-item"
                        exact
                      >
                        MY PIXPILLS
                      </b-link>
                      <b-link to="/accounts/" class="dropdown-item"
                        >EDIT ACCOUNT</b-link
                      >
                      <b-link to="/about/" class="dropdown-item">HELP</b-link>
                      <a href="/accounts/logout/" class="dropdown-item"
                        >LOGOUT</a
                      >
                    </b-nav-item-dropdown>
                    <li class="nav-item">
                      <a href="http://axooagency.com/" target="_blank">
                        <img
                          src="./assets/axoo-logo.png"
                          style="height: 32px;"
                        />
                      </a>
                    </li>
                  </template>
                  <template v-else>
                    <li class="nav-item">
                      <b-link to="/login/" class="nav-link">
                        LOGIN
                      </b-link>
                    </li>
                    <li class="nav-item">
                      <b-link to="/signup/" class="nav-link">
                        SIGN UP
                      </b-link>
                    </li>
                  </template>
                </b-navbar-nav>
              </b-collapse>
            </b-navbar>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="router-view">
      <keep-alive include="home,profile,gallery">
        <router-view />
      </keep-alive>
    </div>

    <div class="footer d-flex flex-column align-items-center p-5">
      <img src="./assets/logo_new.png" class="logo" @click="scrollBackToTop" />

      <div class="links mt-2">
        <a
          href="https://axoo.notion.site/pixpills-x-12f47ee5dd9580099036c403ef8ed499"
          target="_blank"
          class="mr-3"
        >
          About
        </a>
        <router-link to="/about/contact/" class="mr-3">Contact</router-link>
        <a
          href="https://www.notion.so/441c977e812a46d59715a2867db3201a"
          target="_blank"
          class="mr-3"
          >Privacy Policy</a
        >
        <a
          href="https://www.notion.so/590d96138f8c445bb036e643925aa1e7"
          target="_blank"
          >Terms of Use</a
        >
      </div>

      <div class="mt-4">
        <b-button
          href="https://www.instagram.com/pixpills/"
          variant="link"
          target="_blank"
          class="instagram p-0"
        >
          <img src="./assets/instagram_new.png" class="h-100" />
        </b-button>
      </div>

      <div class="mt-2">
        © pixpills 2023
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import objectFitImages from "object-fit-images";
import { getCookie } from "./utils";

// Read per request: the cookie can arrive after this module loads (from the
// bootstrap API when nginx serves index.html) and Django rotates it on login.
axios.interceptors.request.use(config => {
  config.headers["X-CSRFToken"] = getCookie("csrftoken");
  return config;
});

axios.interceptors.response.use(null, error => {
  // Signed out (or the session expired): log in and come back here. The request
  // still fails, so callers don't treat a refused save as a success.
  if (
    error.response &&
    error.response.status === 403 &&
    !location.pathname.startsWith("/login")
  ) {
    const back = encodeURIComponent(location.pathname + location.search);
    window.location = `/login/?redirect=${back}`;
  }

  return Promise.reject(error);
});

export default Vue.component("app", {
  data() {
    return {
      user: window.user
    };
  },
  computed: {
    classes() {
      return this.$route.matched.map(route => route.name);
    }
  },
  mounted() {
    objectFitImages();
  },
  methods: {
    scrollBackToTop() {
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      document.body.scrollTop = 0; // For Safari
    }
  }
});
</script>

<style lang="scss">
$grid-gutter-width: 10px;
@import "~bootstrap/scss/bootstrap";

body {
  font-family: Noto Sans KR, sans-serif;
  font-size: 13px;
}

a:hover {
  text-decoration: none;
}

@media (min-width: 1863px) {
  .container {
    max-width: 70vw !important;
  }
}

.modal-dialog.modal-container {
  @extend .container;
}

.btn {
  border: solid 1px #ededed;
  height: 28px;
  line-height: 18px;
  border-radius: 14px;
  font-size: 13px;
  text-transform: uppercase;
  padding: 4px 14px;
  background-color: black;
  color: white !important;
}

.btn-secondary {
  color: black !important;
  background-color: white;
}

.btn-sm {
  height: 24px;
  border-radius: 12px;
  font-size: 10px;
  line-height: 10px;
  padding: 0 12px;
}

.btn-lg {
  height: 48px;
  border-radius: 24px;
  font-size: 28px;
  padding: 0 32px;
}

.btn-red {
  color: white !important;
  background-color: #b10101;
}

.btn-grey {
  padding: 0 8px 3px 8px;
  background-color: #f6f6f6;
}

.btn-link {
  height: auto;
  padding: 0;
  background-color: transparent;
  color: black !important;
  border: 0;
}

.btn-circle {
  width: 30px;
  height: 30px;
  border-radius: 15px;
}

.btn-outline-success {
  border-color: transparent;
  background-color: transparent;
}

.btn-outline-red {
  color: #b10101;
  border-color: white !important;
  background-color: #b10101;
}

.btn-white-hover {
  color: black !important;
  background-color: white;
  border: solid 1px black;

  &:hover {
    color: white !important;
    background-color: black;
    border: solid 1px black;
  }
}

.btn-red-hover {
  color: white !important;
  background-color: #b10101;

  &:hover {
    color: white !important;
    background-color: black;
  }
}

.btn-white-red-hover {
  color: black !important;
  background-color: white;
  border: solid 1px #b10101;

  &:hover {
    color: white !important;
    background-color: #b10101;
  }
}

.navbar.primary {
  padding: 0;

  @media (min-width: 992px) {
    height: 60px;
  }

  .logo-inverse {
    height: 20px;
  }
}

.navbar-toggler {
  border: 0;
}

.modal-max {
  max-width: 100%;
}

.tooltip-inner {
  max-width: 400px;
  color: black;
  background-color: #f5f5f5;
}

.display-1 {
  font-size: 16px;
}

.display-2 {
  font-size: 14px;
}

.display-3 {
  font-size: 13px;
}

.display-4 {
  font-size: 11px;
}

body.loading-open {
  overflow: hidden;

  .loading {
    display: flex !important;
  }
}

.loading {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1050;

  .wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: black;
    opacity: 0.3;
  }
}

.upload,
.upload-with-artwork,
.application-upload,
.application-upload-with-artwork,
.application-published-with-artwork,
.application-with-artwork,
.application-complete-with-artwork {
  background-color: #ededed;
}

.upload .dropdown-menu {
  width: 188px;
}

.primary-menu .nav-item {
  font-family: Josefin Sans, sans-serif;

  border-bottom: solid 1px white;
  &:first-child {
    border-top: solid 1px white;
  }

  @include media-breakpoint-up(lg) {
    border: none;
    &:first-child {
      border: none;
    }
  }

  .nav-link {
    color: white;
    @media (min-width: 992px) {
      color: rgba(0, 0, 0, 0.5);
    }
  }
}

.navbar-brand {
  width: 100%;
  overflow: hidden;

  img {
    height: 30px;
  }

  .navbar-toggler {
    color: white;
  }
}

.navbar-nav {
  z-index: 0;
}

.dropdown-menu {
  padding: 8px;
  font-size: 13px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

  .dropdown-item {
    padding: 2px 4px;

    &.active {
      color: #212529;
      background-color: transparent;
    }
  }
}

.carousel-inner {
  height: 100%;
}

.card {
  border: none;
}

.text-ellipsis {
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
}

.hover-underline:hover {
  text-decoration: underline;
}

.mce-stack-layout-item.mce-statusbar.mce-last {
  border: none;
}

.mce-flow-layout-item.mce-label.mce-branding.mce-last {
  display: none;
}
</style>

<style lang="scss">
// Styles b-nav-item-dropdown's internal toggle, which scoped CSS can't reach.
.app .fixed-top .secondary-menu .nav-item.avatar .dropdown-toggle {
  padding: 0;

  img {
    height: 32px;
  }

  &::after {
    display: none;
  }
}
</style>

<style lang="scss" scoped>
$grid-gutter-width: 10px;
@import "~bootstrap/scss/bootstrap-grid.scss";

.cover {
  position: fixed;
  top: 0;
  height: 60px;
  width: 100%;
  z-index: 1000;
  background-color: white;
}

.fixed-top {
  position: static;
  background-color: #b10101;

  @include media-breakpoint-up(lg) {
    position: fixed;
    background-color: transparent;
  }

  .secondary-menu {
    .divider {
      border: 1px solid #eaeaea;
      height: 32px;
      margin-left: 12px;
      margin-right: 12px;
    }

    .nav-item {
      margin-left: 4px;
      margin-right: 4px;
    }
  }
}

.router-view {
  @include media-breakpoint-up(lg) {
    padding-top: 60px;
  }
}

.gallery .router-view {
  @include media-breakpoint-up(lg) {
    padding-top: 88px;
  }
}

.footer {
  background-color: #b10101;
  color: white;

  .logo {
    width: 100px;
    cursor: pointer;
  }

  input {
    text-align: center;
  }
  .links a {
    color: white;
  }
}

.artwork .footer {
  display: none !important;
}

.instagram {
  height: 40px;
}
</style>
